import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oficina-maintenance',
  templateUrl: './oficina-maintenance.component.html',
  styleUrls: ['./oficina-maintenance.component.scss']
})
export class OficinaMaintenanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
